/**
 * Escapes special regex characters in a string so it can be safely used in RegExp.
 * Prevents ReDoS and invalid regex when user search contains e.g. parentheses.
 */
export function escapeRegex(str: string): string {
	return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

/**
 * Escapes HTML special characters to prevent XSS when inserting API data into the DOM.
 */
export function escapeHtml(str: string): string {
	const div = document.createElement('div');
	div.textContent = str;
	return div.innerHTML;
}

/**
 * Wraps each case-insensitive match of `needle` in `haystack` with a tag name,
 * returning safe HTML (needle and haystack are escaped). Used for search result highlighting.
 */
export function highlightMatch(haystack: string, needle: string, tagName: string = 'strong'): string {
	if (!needle.trim()) return escapeHtml(haystack);
	const escaped = escapeHtml(haystack);
	const safeNeedle = escapeRegex(needle);
	const regex = new RegExp(`(${safeNeedle})`, 'gi');
	return escaped.replace(regex, `<${tagName}>$1</${tagName}>`);
}
